import { Alert, Alignment, Button, FormGroup, HTMLSelect, Icon, NonIdealState } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { IEmpresa, newEmpresa } from "../../model";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { SpedTransmissaoStore } from "../../stores/sped/SpedTransmissaoStore";
import { Pager } from "../utils/Pager";
import { formatCnpj } from "../../utils";
import { getTag } from "../utils/getStatus";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ptBR } from "@mui/x-date-pickers/locales";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import { toast } from "react-toastify";
import LoadingModal from "../loading/LoadingModal";
import Dropzone from "react-dropzone";
import { AppIcon } from "../utils/AppIcon";

@observer
export class SpedTransmissoesPage extends React.Component<{}, {}> {

  obs = observable({
    selectEmpresa: newEmpresa() as IEmpresa,
    current_page: 1 as number,
    data_agendamento: null as Dayjs,
    tipo: "" as string,
    selectedRows: [] as any,
    tarefa: {} as any,
    open_detalhes: false as boolean,

    selectedEmpresaImport: newEmpresa() as IEmpresa,
    tipoImport: "" as string,
    importarTxt: false as boolean,
  })

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {

    this.handleBuscaInitial()

  }

  async handleBuscaInitial() {

    this.obs.selectEmpresa = newEmpresa()

    await SpedTransmissaoStore.handleTasksPaged(
      this.obs.current_page = 1,
      this.obs.selectEmpresa.cnpj,
      this.obs.data_agendamento = null,
      this.obs.tipo = ""
    );

  }

  async handleChangePage(page: number) {

    this.obs.current_page = page

    await SpedTransmissaoStore.handleTasksPaged(
      this.obs.current_page,
      this.obs.selectEmpresa.cnpj,
      this.obs.data_agendamento,
      this.obs.tipo,
    );

  }

  handleDetalhesSolicitacao(row: any) {

    this.obs.tarefa = row

    this.obs.open_detalhes = true

  }

  handlePeriodo = (value: any) => {

    this.obs.data_agendamento = value

    this.handleChangePage(1)

  };

  onCloseImportarXmls() {

    this.obs.importarTxt = false

    this.obs.selectedEmpresaImport = newEmpresa()

  }

  handleFileDropEntrada = async (files: any) => {

    if (!this.obs.selectedEmpresaImport.cnpj) {
      toast.warning("Você precisa selecionar uma Empresa", {});
      return
    }

    if (!this.obs.tipoImport) {
      toast.warning("Você precisa selecionar um Tipo", {});
      return
    }

    var data = new FormData();

    data.append("file", files[0])
    data.append("cnpj", this.obs.selectedEmpresaImport.cnpj)
    data.append("razao_social", this.obs.selectedEmpresaImport.razao_social)
    data.append("tipo", this.obs.tipoImport)

    this.obs.importarTxt = false;

    await SpedTransmissaoStore.handldeCreateTaskImport(data);

    this.handleChangePage(1)

  };

  handleFileDropRejected = async (files: any) => {

    if (files.length > 1) {
      toast.warning("Apenas um arquivo por vez é liberado para importação.", {});
      return;
    }

    toast.warning("Arquivo inválido, é aceito somente arquivos .txt", {});
    return;

  };

  render() {

    function statusFormatter(cell, row) {

      return getTag(row.status, row.tipo);

    }

    function relatorioFormatter(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={[0, 1, 3].includes(row.status)}
            onClick={() => SpedTransmissaoStore.handleDownloadRelatorio(row.sped_id, row.cnpj)}
          >
            <img src="/images/view.svg" />
          </MDBBtn>
        </>
      );
    }

    function fileFormatter(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => SpedTransmissaoStore.handleDownloadArquivoSped(row.arquivo_id, row.cnpj)}
          >
            <AppIcon name="download" color="#1b636f" />
          </MDBBtn>
        </>
      );
    }

    const detalhesFormatter = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={[0, 1, 19].includes(row.status)}
            onClick={() => this.handleDetalhesSolicitacao(row)}
          >
            <img src="/images/view.png" />
          </MDBBtn>
        </>
      );
    }

    let items = SpedTransmissaoStore.obs.tasks_sped?.map(imp => {
      return (
        {
          id: imp._id,
          cnpj: imp.cnpj,
          razao_social: imp.razao_social,
          inserted_at: imp.inserted_at,
          status: imp.status,
          tipo: imp.tipo,
          sped_id: imp.sped_id,
          arquivo_id: imp.arquivo_id,
          error: imp.error || [],
        }
      );
    });

    const dateFormatter = (cell, row) => {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
    };

    const cnpjFormatter = (cell, row) => {
      return formatCnpj(row.cnpj)
    };

    const tipoFormatter = (cell, row) => {
      return (row.tipo).toUpperCase()
    };

    let empresaText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa (opcional)"

    let empresaTextImport = this.obs.selectedEmpresaImport.razao_social != ""
      ? `${this.obs.selectedEmpresaImport.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectedEmpresaImport.cnpj)})`
      : "Selecione uma empresa";

    return (<>

      <MDBRow>
        <MDBCol md="3">
          <FormGroup className="empresaSelect" label="Empresa">
            <EmpresaSelect
              items={EmpresaStore.sortedEmpresas}
              itemRenderer={renderEmpresa}
              itemPredicate={filterEmpresa}
              onItemSelect={(e: IEmpresa) => {
                this.obs.selectEmpresa = e
                this.handleChangePage(1)
              }}
              inputProps={{ placeholder: "Filtrar uma empresa" }}
            >
              <Button
                text={empresaText}
                alignText={Alignment.LEFT}
                rightIcon={
                  this.obs.selectEmpresa.cnpj ? (
                    <Icon
                      className="clear-icon-empresa"
                      icon="cross"
                      onClick={(ev) => {
                        ev.stopPropagation();
                        this.obs.selectEmpresa = newEmpresa();
                        this.handleChangePage(1);
                      }}
                    />
                  ) : (
                    <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                  )
                }
              />
            </EmpresaSelect>
          </FormGroup>
        </MDBCol>

        <MDBCol md="2">
          <FormGroup label="Tipo">
            <HTMLSelect
              onChange={(e) => {
                this.obs.tipo = e.target.value
                this.handleChangePage(1)
              }}
              value={this.obs.tipo}
            >
              <option value={""}>Todos</option>
              <option value={"sped_validar"}>Validar</option>
              <option value={"sped_transmitir"}>Transmitir</option>
            </HTMLSelect>
          </FormGroup>
        </MDBCol>

        <MDBCol md="3">
          <FormGroup label="Data do Agendamento">
            <LocalizationProvider
              localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
              adapterLocale={"pt-br"}
              dateAdapter={AdapterDayjs}>
              <DatePicker
                value={this.obs.data_agendamento}
                className="input-data-apuracao"
                views={['month', 'year']}
                onChange={(value) => this.handlePeriodo(value)}
                format="MM/YYYY"
                slotProps={{
                  textField: { size: 'small' },
                  field: { clearable: true, onClear: () => this.handlePeriodo(null) },
                }}
              />
            </LocalizationProvider>
          </FormGroup>
        </MDBCol>

        <MDBCol md="1">
          <FormGroup label={"\u200B"}>
            <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => this.handleChangePage(1)} style={{ marginTop: 3 }}>
              Buscar
            </MDBBtn>
          </FormGroup>
        </MDBCol>

      </MDBRow>

      <MDBRow>
        <MDBCol md="12">
          <MDBBtn
            className="btnDefault btnImportarXmls"
            onClick={() => {
              this.obs.selectedEmpresaImport = newEmpresa();
              this.obs.tipoImport = "";
              this.obs.importarTxt = true;
            }}
            style={{ float: "right" }}
            data-tut="importar_xmls"
          >
            Validar Arquivo
          </MDBBtn>
        </MDBCol>
      </MDBRow>

      <BootstrapTable className="TableDefault TableSped TableSpedTrans" data={items}>
        <TableHeaderColumn dataField="sped_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
        <TableHeaderColumn dataField="razao_social" width="30%">Razão Social</TableHeaderColumn>
        <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
        <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data do Agendamento</TableHeaderColumn>
        <TableHeaderColumn dataFormat={tipoFormatter} width="20%">Tipo</TableHeaderColumn>
        <TableHeaderColumn dataField="status" dataFormat={statusFormatter} width="40%">Status</TableHeaderColumn>
        <TableHeaderColumn dataFormat={fileFormatter} dataAlign="center" width="10%">SPED</TableHeaderColumn>
        <TableHeaderColumn dataFormat={relatorioFormatter} dataAlign="center" width="10%">Relatório</TableHeaderColumn>
        <TableHeaderColumn dataFormat={detalhesFormatter} dataAlign="center" width="10%">Detalhes</TableHeaderColumn>
      </BootstrapTable>

      <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
        <Pager
          currentPage={this.obs.current_page}
          totalCount={SpedTransmissaoStore.obs.length_tasks_sped}
          pageSize={15}
          onPageChange={page => this.handleChangePage(page)}
        />
      </div>

      <Alert
        confirmButtonText="Fechar"
        isOpen={this.obs.importarTxt}
        onClose={() => this.onCloseImportarXmls()}
        canOutsideClickCancel={true}
      >
        <h2 className="titleSEFAZ">Validar arquivo SPED</h2>
        <MDBRow>
          <MDBCol md="8">
            <FormGroup className="empresaSelectImport" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresaImport = e}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaTextImport}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="4">
            <FormGroup label="Tipo">
              <HTMLSelect
                style={{ width: "100%" }}
                onChange={(e) => this.obs.tipoImport = e.target.value}
                value={this.obs.tipoImport}
              >
                <option value={""}>Selecione</option>
                <option value={"sped_validar"}>Validar</option>
                <option value={"sped_transmitir"}>Transmitir</option>
              </HTMLSelect>
            </FormGroup>
          </MDBCol>

        </MDBRow>

        {this.obs.selectedEmpresaImport.razao_social == "" ?
          <div>
            <NonIdealState
              icon="box"
              title="Selecione a empresa para a qual deseja validar o arquivo SPED."
            />
          </div>
          :
          <div>
            <Dropzone
              accept={{
                "files/txt": [".txt"],
              }}
              maxFiles={1}
              multiple={false}
              onDropAccepted={this.handleFileDropEntrada}
              onDropRejected={this.handleFileDropRejected}
            >
              {({ getRootProps, getInputProps }) => (
                <>
                  <div {...getRootProps()} style={{ marginBottom: 20 }}>
                    <input {...getInputProps()} />
                    <Button
                      icon="upload"
                      text="Selecionar SPED para upload"
                      className="btn-file btnDefault noMargin"
                    />
                  </div>

                  <div {...getRootProps()} className="nz-upload-box">
                    <input {...getInputProps()} />
                    <Icon icon="upload" iconSize={60} />
                    <span style={{ marginLeft: 20 }}>
                      Arraste o arquivo para importar.{" "}
                    </span>
                  </div>
                </>
              )}
            </Dropzone>
          </div>

        }

      </Alert>

      <Alert
        confirmButtonText="Fechar"
        isOpen={this.obs.open_detalhes}
        onClose={() => this.obs.open_detalhes = false}
        onConfirm={() => this.obs.open_detalhes = false}
        canOutsideClickCancel={true}
        className="AlertErrorSped"
      >
        <MDBCol md="12">
          <h2 className="titleSEFAZ">Erros</h2>
          {this.obs.tarefa.error &&
            <div className="errosSped">
              <BootstrapTable className="nomeArquivos" data={[this.obs.tarefa]} hover>
                <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                <TableHeaderColumn dataField='error' width='100%'></TableHeaderColumn>
              </BootstrapTable>
            </div>
          }
        </MDBCol>
      </Alert>

      <LoadingModal open={SpedTransmissaoStore.obs.loadingImport} onClose={() => SpedTransmissaoStore.obs.loadingImport = false} title={"Importando arquivo"} />
      <LoadingModal open={SpedTransmissaoStore.obs.loading} onClose={() => SpedTransmissaoStore.obs.loading = false} title={"Baixando arquivo"} />

    </>)

  }

}

export default SpedTransmissoesPage;
